import { useEffect, useState } from 'react';

// Utils
import { getSeasons } from '../../../../packages/services/basketball/common';

// Types
import { IBasketballSeasonsResponseV2, ISeasonV2, ICompetitionV2, SDKOptions, IConfigEntityLinks } from '../../../../packages/types';
import { normalizedCompetitionResponseData } from '../normalizers/normalizeCompetitionResponseData';

interface ICompetition {
  id: string;
  title: string;
  logo: string;
  urlTarget: string;
  url: string;
}

interface IUseCompetitionSeasonArgs {
  dataSeason?: string;
  competitionId?: string;
  sdkOptions: SDKOptions;
  dataEntityLinks?: IConfigEntityLinks | null;
}

export const useCompetitionSeasons = ({ competitionId, dataSeason, dataEntityLinks, sdkOptions }: IUseCompetitionSeasonArgs) => {
  const [seasonId, setSeasonId] = useState(dataSeason);
  const [competition, setCompetition] = useState<ICompetition | undefined>();
  const [seasons, setSeasons] = useState<ISeasonV2[]>();

  useEffect(() => {
    if (competitionId) {
      getSeasons({ params: { competition_id: competitionId }, sdkOptions })
        ?.then(({ seasons }: IBasketballSeasonsResponseV2) => {
          const competition = normalizedCompetitionResponseData({
            competition: seasons && seasons.length > 0 ? seasons[0].competition : undefined,
            dataEntityLinks,
          });
          setCompetition(competition);
          setSeasons(seasons);
        })
        .catch((error: unknown) => {
          console.error(error);
        });
    }
  }, [competitionId]);

  useEffect(() => {
    if (seasons && seasons?.length > 0 && !seasonId) {
      setSeasonId(seasons[0].id);
    }
  }, [seasonId, seasons]);

  const seasonOptions =
    seasons?.map(({ name, id }) => ({
      label: name,
      value: id,
    })) ?? [];

  return {
    competition,
    seasonId,
    setSeasonId,
    seasonOptions,
  };
};
